import React from 'react';
import type { Color } from '../../styles/variables';
import { COLORS } from '../../styles/variables';

interface CheckMarkIconProps {
  color?: Color;
  size?: number;
}

const CheckMarkIcon: React.FC<CheckMarkIconProps> = ({ color = COLORS.grey80, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.45386 10.1234L7.99878 13.5512L14.6817 5.2504" stroke={color} />
  </svg>
);

export default CheckMarkIcon;
